export const locations = {
  'Call Center': 'CallCenter',
  'Contract Manufacturer': 'ContractManufacturer',
  'Data Center': 'DataCenter',
  'External Location': 'ExternalLocation',
  'Finished Goods Warehouse': 'FinishedGoodsWarehouse',
  Manufacturing: 'Manufacturing',
  Office: 'Office',
  'Test Facility': 'TestFacility',
  'Third Party Logistics': 'ThirdPartyLogistics',
  'Distribution Center': 'DistributionCenter',
  Supplier: 'Supplier',
  Other: 'Other',
};

const formFields = [
  {
    key: 'locationName',
    label: 'Name',
    isRequired: true,
  },
  {
    key: 'locationType',
    label: 'Type',
    isRequired: true,
    type: 'select',
    options: [
      { label: 'Call Center', value: 'CallCenter' },
      { label: 'Contract Manufacturer', value: 'ContractManufacturer' },
      { label: 'Data Center', value: 'DataCenter' },
      { label: 'External Location', value: 'ExternalLocation' },
      { label: 'Finished Goods Warehouse', value: 'FinishedGoodsWarehouse' },
      { label: 'Manufacturing', value: 'Manufacturing' },
      { label: 'Office', value: 'Office' },
      { label: 'Test Facility', value: 'TestFacility' },
      { label: 'Third Party Logistics', value: 'ThirdPartyLogistics' },
      { label: 'Distribution Center', value: 'DistributionCenter' },
      { label: 'Supplier', value: 'Supplier' },
      { label: 'Other', value: 'Other' },
    ],
  },
  {
    key: 'street',
    label: 'Street',
  },
  {
    key: 'city',
    label: 'City',
  },
  {
    key: 'state',
    label: 'State',
  },
  {
    key: 'zipCode',
    label: 'Zip Code',
  },
  {
    key: 'country',
    label: 'Country',
    isRequired: true,
  },
  {
    key: 'rebuildTime',
    label: 'Rebuild Time',
    type: 'time',
    decoratorWord: 'months',
    isRequired: true,
  },
  {
    key: 'rebuildCost',
    label: 'Rebuild Cost',
    type: 'money',
    defaultValue: 0,
  },
];

export { formFields };
